import React, { useState, useEffect, useRef } from "react";
import '../../css/style.css'
import Modal from "./Modal";

const Perevozki = (props) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [intervalId, setIntervalId] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [fade, setFade] = useState(true);
    const [isHoveredButton1, setIsHoveredButton1] = useState(false);
    const [isHoveredButton2, setIsHoveredButton2] = useState(false);
    const sliderRef = useRef(null);

    const resetTransportAnimation = () => {
        const transportSlider = document.getElementById("transportSlider");
        const MobTransportSlider = document.getElementById("MobTransportSlider");

        if (transportSlider) {
            transportSlider.style.transition = 'none';
            transportSlider.style.transform = `translateX(0)`;
            setTimeout(() => {
                transportSlider.style.transition = '';
                transportSlider.style.transform = `translateX(${calculateTransportPosition()}px)`;
            }, 50);
        }

        if (MobTransportSlider) {
            MobTransportSlider.style.transition = 'none';
            MobTransportSlider.style.transform = `translateX(0)`;
            setTimeout(() => {
                MobTransportSlider.style.transition = '';
                MobTransportSlider.style.transform = `translateX(${calculateMobTransportPosition()}px)`;
            }, 50);
        }
    };

    const calculateTransportPosition = () => {
        const road = document.getElementById('road');
        return road ? (road.offsetWidth - document.getElementById("transportSlider").offsetWidth - 10) : 0;
    };

    const calculateMobTransportPosition = () => {
        const MobRoad = document.getElementById('MobRoad');
        return MobRoad ? (MobRoad.offsetWidth - document.getElementById("MobTransportSlider").offsetWidth - 10) : 0;
    };

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
            if (entry.isIntersecting) {
                resetTransportAnimation(); // Reset animation when the block comes into view
            }
        });

        if (sliderRef.current) {
            observer.observe(sliderRef.current);
        }

        return () => {
            if (sliderRef.current) {
                observer.unobserve(sliderRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            resetTransportAnimation(); // Reset animation initially when visible
            const id = setInterval(() => {
                setFade(false);
                setTimeout(() => {
                    setCurrentIndex((prevIndex) => (prevIndex + 1) % props.data.slides.length);
                    setFade(true);
                    resetTransportAnimation();
                }, 500);
            }, 6000);
            setIntervalId(id);
        } else {
            clearInterval(intervalId);
        }

        return () => clearInterval(intervalId);
    }, [isVisible]);

    const restartInterval = () => {
        clearInterval(intervalId);
        const id = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % props.data.slides.length);
                setFade(true);
                resetTransportAnimation();
            }, 500);
        }, 6000);
        setIntervalId(id);
    };

    const nextSlide = () => {
        setFade(false);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % props.data.slides.length);
            setFade(true);
            resetTransportAnimation();
            restartInterval(); // Restart interval on manual slide change
        }, 500);
    };

    const prevSlide = () => {
        setFade(false);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + props.data.slides.length) % props.data.slides.length);
            setFade(true);
            resetTransportAnimation();
            restartInterval(); // Restart interval on manual slide change
        }, 500);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="my-[100px] max-w-[1430px] flex flex-col mx-auto w-[98%]" ref={sliderRef}>
            <div className={`mb-[32px] text-[${props.data.colors[0].colorBlack}]`}>
                <div className="text-[28px] md:text-[40px] font-medium">
                    {props.data.texts[0].title}
                </div>
            </div>

            <div className="flex lg:h-[575px] sm:h-[530px] sm:flex-nowrap flex-wrap justify-between gap-[16px]">
                <div style={{ background: props.data.colors[0].colorGrey1 }} className={`h-full rounded-[20px] p-[24px] `}>
                    <div className="lg:h-full flex sm:flex-nowrap flex-wrap gap-[32px] sm:gap-[48px]">
                        <div className={`slide-el rounded-[20px] ${fade ? 'visible' : ''}`}>
                            <img className="rounded-[20px] lg:h-full sm:h-[335px] object-none" src={props.data.slides[currentIndex].image} alt={props.data.slides[currentIndex].title} />
                        </div>
                        <div className={`slide-el sm:h-[335px] lg:h-full flex flex-col justify-between ${fade ? 'visible' : ''}`}>
                            <div className="h-full">
                                <div style={{ color: props.data.colors[0].colorBlack }} className={`font-medium flex gap-[32px] sm:gap-[50px] mb-[32px] sm:mb-[40px] pr-[48px] pt-[23px] flex-wrap`}>
                                    <div className="max-w-[340px]">
                                        <div className="text-[24px] md:text-[32px] mb-[16px]">{props.data.slides[currentIndex].title}</div>
                                        <div className="text-[14px] md:text-[16px] leading-[1.2]">{props.data.slides[currentIndex].description}</div>
                                    </div>
                                    <div className="bg-[#fff] p-[16px] rounded-[12px] min-w-[165px] max-h-[94px]">
                                        <div className="text-[#4B535B] text-[14px] flex items-center gap-[8px] mb-[8px]">
                                            <img src="/img/slider/kalendarik.svg" alt="Календарь" />
                                            {props.data.texts[0].text1}
                                        </div>
                                        <div style={{ color: props.data.colors[0].colorBlack }} className={`text-[16px]`}>
                                            <span className="text-[26px]">{props.data.slides[currentIndex].deliveryTime}</span> {props.data.texts[0].text2}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-wrap gap-[12px] mb-[40px] sm-mb-[0] items-center">
                                    <a
                                        href={props.data.buttons[0].link}
                                        onMouseEnter={() => setIsHoveredButton1(true)}
                                        onMouseLeave={() => setIsHoveredButton1(false)}
                                        style={{
                                            background: isHoveredButton1 ? props.data.buttons[0].bgHover : props.data.buttons[0].bg,
                                            color: props.data.buttons[0].color,
                                            border: `1px solid ${isHoveredButton1 ? props.data.buttons[0].bgHover : props.data.buttons[0].bg}`
                                        }}
                                        className="py-[12px] px-[20px] flex items-center gap-[7px] rounded-[30px] duration-300"
                                    >
                                        {props.data.buttons[0].text}
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.25811 2.24219L3.25811 0.242188H12.7434V9.72747H10.7434V3.6564L1.8439 12.5559L0.429688 11.1417L9.32918 2.24219H3.25811Z" fill="#EFF0F2" />
                                        </svg>
                                    </a>
                                    <a
                                        onClick={handleOpenModal}
                                        onMouseEnter={() => setIsHoveredButton2(true)}
                                        onMouseLeave={() => setIsHoveredButton2(false)}
                                        style={{
                                            background: isHoveredButton2 ? props.data.buttons[1].bgHover : 'transparent',
                                            color: isHoveredButton2 ? props.data.buttons[1].hoverColor : props.data.buttons[1].color,
                                            border: `1px solid ${isHoveredButton2 ? props.data.buttons[1].bgHover : props.data.buttons[1].bgHover}`
                                        }}
                                        className="py-[12px] px-[20px] rounded-[30px] flex items-center gap-[7px] duration-300"
                                    >
                                        {props.data.buttons[1].text}
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.25811 2.24219L3.25811 0.242188H12.7434V9.72747H10.7434V3.6564L1.8439 12.5559L0.429688 11.1417L9.32918 2.24219H3.25811Z" fill={isHoveredButton2 ? props.data.buttons[1].hoverColor : props.data.buttons[1].bgHover} />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div className="w-[100%] lg:block relative hidden">
                                <img id='transportSlider' className={`transportSlider duration-[6000ms] ease-linear ${currentIndex === 1 ? 'mt-[-15px] xl:mt-[-10px]' : 'mt-[-28px] xl:mt-[-25px]'}`} src={props.data.slides[currentIndex].transportImage} alt="Транспорт" />
                                <img id="road" src="/img/slider/dorogaDesc.svg" className="w-full" alt="Описание дороги" />
                            </div>
                        </div>
                    </div>
                    <div className="sm:mt-[130px] w-[100%] lg:hidden">
                        <img id='MobTransportSlider' className={`transportSlider duration-[6000ms] ease-linear ${currentIndex === 1 ? 'mt-[-12px]' : 'mt-[-25px]'}`} src={props.data.slides[currentIndex].transportImage} alt="Транспорт" />
                        <img id="MobRoad" className="w-full" src="/img/slider/dorogaDesc.svg" alt="Описание дороги" />
                    </div>
                </div>

                <div style={{ background: props.data.colors[0].colorGrey1 }} className={`h-full sm:min-h-[520px] flex sm:flex-col justify-between  rounded-[20px] p-[10px] sm:py-[24px] w-full sm:w-[90px] px-[20px]`}>
                    <div className="text-[16px] flex items-end text-[#4B535B]">
                        <div className="text-[#1F2225] text-[56px] sm:text-[64px]">{currentIndex + 1}</div> <div>/{props.data.slides.length}</div>
                    </div>
                    <div className="flex sm:flex-col">
                        <button onClick={prevSlide}>
                            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.3211 8.82227L13.1426 20.0008L24.3211 31.1793L26.6781 28.8223L17.8566 20.0008L26.6781 11.1793L24.3211 8.82227Z" fill="#626C75" />
                            </svg>
                        </button>
                        <button onClick={nextSlide}>
                            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.6793 8.82227L27.8578 20.0008L16.6793 31.1793L14.3223 28.8223L23.1438 20.0008L14.3223 11.1793L16.6793 8.82227Z" fill="#626C75" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
        </div>
    );
}

export default Perevozki;
